"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.list.name': 'Nazwa Testu',
    'botTest.list.date': 'Data Testu',
    'botTest.list.testersCount': 'Testerzy',
    'botTest.list.targetsCount': 'Cele',
};
